module.exports = __webpack_public_path__ + "static/media/search.8d6dcd12.svg";